export default __webpack_public_path__ + "static/media/back-btn-arrow-cms.c1a84195.svg";